export type MediaType = "video" | "audio" | "image" | "unknown";

export function getMediaTypeFromFilename(filename: string): MediaType {
  if (!filename || typeof filename !== "string") {
    return "unknown";
  }

  const lastDotIndex = filename.lastIndexOf(".");

  if (
    lastDotIndex === -1 ||
    lastDotIndex === 0 ||
    lastDotIndex === filename.length - 1
  ) {
    return "unknown";
  }

  const extension = filename.substring(lastDotIndex).toLowerCase();

  const videoExtensions = [".mp4", ".mpeg", ".webm", ".mov", ".avi"];
  if (videoExtensions.includes(extension)) {
    return "video";
  }

  const audioExtensions = [".mp3", ".mpga", ".m4a", ".wav", ".ogg"];
  if (audioExtensions.includes(extension)) {
    return "audio";
  }

  const imageExtensions = [".png", ".jpeg", ".jpg", ".gif", ".heic"];
  if (imageExtensions.includes(extension)) {
    return "image";
  }

  return "unknown";
}
